import { byBrand } from "@repo/tailwind-config/brand";

/**
 * Fixed pricing plan keys for Stripe products.
 * Owlet uses brand-specific Stripe prices (separate pricing from Kinsa).
 */
export function usePricingPlanKeys() {
  return pricingPlanKeys;
}

export const pricingPlanKeys = {
  unlimitedRx: {
    monthly: "fast_rx_monthly_29",
    yearly: "yearly_rx_199",
  },
  pediatricSupport: byBrand({
    owlet: {
      monthly: "pediatric_care_monthly_high_owlet",
      yearly: "pediatric_care_yearly_high_owlet",
    },
    default: {
      monthly: "pediatric_care_monthly_high",
      yearly: "pediatric_care_yearly_high",
    },
  }),
  // Owlet OnCall Single — used by the 2-product paywall experiment Test variant.
  // Owlet-only product; Kinsa fallback maps to the existing pediatricSupport keys.
  pediatricSupportSingle: byBrand({
    owlet: { monthly: "single_child_monthly", yearly: "single_child_yearly" },
    default: {
      monthly: "pediatric_care_monthly_high",
      yearly: "pediatric_care_yearly_high",
    },
  }),
  // Owlet OnCall Family — used by the 2-product paywall experiment Test variant.
  pediatricSupportFamily: byBrand({
    owlet: { monthly: "all_children_monthly", yearly: "all_children_yearly" },
    default: {
      monthly: "pediatric_care_monthly_high",
      yearly: "pediatric_care_yearly_high",
    },
  }),
  // Owlet front-door experiment (PE-1471): dedicated no-trial products, kept
  // separate from the shared keys above so the dark experiment never disturbs
  // the live paywalls. Owlet-only; Kinsa never renders these front-door variants.
  owletOnCall: {
    monthly: "oncall_only_monthly",
    yearly: "oncall_only_yearly",
  },
  owletBase: {
    monthly: "base_plan_monthly",
    yearly: "base_plan_yearly",
  },
  owletPremium: {
    monthly: "premium_plan_monthly",
    yearly: "premium_plan_yearly",
  },
  kinsaClinic: {
    monthly: "fast_rx_monthly_29",
    yearly: "yearly_rx_199",
  },
  // Legacy keys for backward compatibility
  kinsa_clinic_yearly: {
    monthly: "kinsa_clinic_monthly",
    yearly: "kinsa_clinic_yearly",
  },
  kinsa_clinic_monthly: {
    monthly: "kinsa_clinic_monthly",
    yearly: "kinsa_clinic_yearly",
  },
};

export type PricingPlanKeys =
  | "unlimitedRx"
  | "pediatricSupport"
  | "pediatricSupportSingle"
  | "pediatricSupportFamily"
  | "owletOnCall"
  | "owletBase"
  | "owletPremium"
  | "kinsaClinic"
  | "kinsa_clinic_monthly"
  | "kinsa_clinic_yearly";
